if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.querySelector('span').classList.add('hidden');
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      if (this.form) {
        const managedSellingPlan = this.form.querySelector('input[name="selling_plan"][data-managed-selling-plan]');
        if (managedSellingPlan) {
          this.form.querySelectorAll('input[name="selling_plan"]:not([data-managed-selling-plan])').forEach((input) => {
            input.disabled = true;
          });
        }
      }

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }

      const redirectToCheckout = this.dataset.redirectToCheckout === 'true';
      const clearCart = this.dataset.clearCart === 'true';

      if (this.cart && !redirectToCheckout) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      const giftItem = this.getGiftWithPurchaseItem(formData.get('id'));
      if (giftItem) {
        const sellingPlan = formData.get('selling_plan');
        const mainItem = {
          id: formData.get('id'),
          quantity: Number(formData.get('quantity')) || 1,
        };
        const properties = this.formDataToProperties(formData);
        if (Object.keys(properties).length) mainItem.properties = properties;
        if (sellingPlan) mainItem.selling_plan = sellingPlan;

        const sectionsValue = formData.get('sections');
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify({
          items: [mainItem, giftItem],
          sections: sectionsValue ? sectionsValue.split(',') : undefined,
          sections_url: formData.get('sections_url'),
        });
      } else {
        config.body = formData;
      }

      const clearCartRequest = clearCart
        ? fetch(`${routes.cart_clear_url || '/cart/clear'}.js`, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        : Promise.resolve();

      clearCartRequest
        .then(() => fetch(`${routes.cart_add_url}`, config))
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (redirectToCheckout) {
            window.location = window.routes.checkout_url || '/checkout';
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.handleUpsellContent();
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.querySelector('span').classList.remove('hidden');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    getGiftWithPurchaseItem(variantId) {
      if (!this.dataset.sectionId) return null;
      const promo = document.querySelector(`gift-with-purchase-promo[data-section-id="${this.dataset.sectionId}"]`);
      if (!promo || promo.dataset.promoActive !== 'true') return null;

      const eligibleIds = (promo.dataset.eligibleVariantIds || '').split(',').filter(Boolean);
      if (!eligibleIds.includes(String(variantId))) return null;

      const giftVariantId = promo.dataset.giftVariantId;
      if (!giftVariantId) return null;

      return {
        id: giftVariantId,
        quantity: Number(promo.dataset.giftQuantity) || 1,
        properties: {_gift_with_purchase: 'true'},
      };
    }

    formDataToProperties(formData) {
      const properties = {};
      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match) properties[match[1]] = value;
      }
      return properties;
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
